import { createSlice } from '@reduxjs/toolkit';
import { getLastMonths } from '../utils/date';

interface MonthState {
  selectedMonth: string;
  monthOptions: string[];
}

const initialState: MonthState = {
  selectedMonth: getLastMonths()[0], // first month as default
  monthOptions: getLastMonths(),
};

const monthSlice = createSlice({
  name: 'month',
  initialState,
  reducers: {
    setSelectedMonth(state, action) {
      state.selectedMonth = action.payload;
    },
  },
});

export const { setSelectedMonth } = monthSlice.actions;
export default monthSlice.reducer;
